import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import ArchiveCampaignButton from "./ArchiveCampaignButton";
import CampaignsSelector from "./CampaignsSelector";
import CopyTrackingPixelButton from "./CopyTrackingPixelButton";
import EditCampaignDetailsButton from "./EditCampaignDetailsButton";
import TimeFrameSelector from "./TimeFrameSelector";
import { BrandgenCampaignPool } from "../../../../../types/campaignTypes";
import { SelectOptionType } from "../../../../../components/elements/Select/Select";
import { truncateText } from "../../../../../helpers/truncateText";
import { useCampaignDashboardStyles } from "../../CampaignDashboardStylesContext";

type CampaignReportDashboardToolbarProps = {
  selectedTimeFrame: string;
  handleTimeFrameChange: (e: any) => void;
  selectedCampaignPool: BrandgenCampaignPool;
  campaignOptions?: SelectOptionType[];
  handleChangeSelectedCampaign?: (e: any) => void;
  fetchAndSetCampaigns: () => void;
  hideCampaignSelector?: boolean;
};

const CampaignReportDashboardToolbar: FC<CampaignReportDashboardToolbarProps> = ({
  selectedTimeFrame,
  handleTimeFrameChange,
  selectedCampaignPool,
  campaignOptions,
  handleChangeSelectedCampaign,
  fetchAndSetCampaigns,
  hideCampaignSelector = false,
}) => {
  const classes = useCampaignDashboardStyles();
  return (
    <div className={classes.campaignReportDashboardToolbar}>
      <Tooltip title={selectedCampaignPool.name}>
        <Typography variant="h3">{truncateText(selectedCampaignPool?.name, 40)}</Typography>
      </Tooltip>

      <div className={classes.toolbarControls}>
        <TimeFrameSelector selectedTimeFrame={selectedTimeFrame} handleTimeFrameChange={handleTimeFrameChange} />

        {!hideCampaignSelector && campaignOptions && handleChangeSelectedCampaign ? (
          <CampaignsSelector
            options={campaignOptions}
            selectedCampaignPool={selectedCampaignPool}
            handleChangeSelectedCampaign={handleChangeSelectedCampaign}
          />
        ) : null}

        <EditCampaignDetailsButton campaignToEdit={selectedCampaignPool} fetchAndSetCampaings={fetchAndSetCampaigns} />

        <CopyTrackingPixelButton pixelEventId={selectedCampaignPool.pixel_event_id} />

        <ArchiveCampaignButton campaignToArchive={selectedCampaignPool} fetchAndSetCampaings={fetchAndSetCampaigns} />
      </div>
    </div>
  );
};

export default CampaignReportDashboardToolbar;
